/***       invoiceApply   发票申请     ***/
<template>
  <div class="invoiceApply">
    <div class="row row1">
      <div class="row-title">
        请选择发票类型
      </div>
      <div class="row-val">
        <div class="val-col" style="text-align: center">
          <!--<div class="col-label">-->
          <!--</div>-->
          <div class="col-val">
            <div class="radio-but" :ac="form.invoices_type==1" @click="form.invoices_type=1">
              电子发票
            </div>
            <div class="radio-but" :ac="form.invoices_type==2" @click="form.invoices_type=2">
              纸质发票
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row row2">
      <div class="row-title">
        发票详情
      </div>
      <div class="row-val">
        <div class="val-col">
          <div class="col-label">
            抬头类型
          </div>
          <div class="col-val">
            <span @click="form.title_type=1">
              <div class="radio-round-but" :ac="form.title_type==1">
                <i class="iconfont icon-chenggong"></i>
              </div>
              企业抬头
            </span>
            <span style="margin-left: 1rem" @click="form.title_type=2">
              <div class="radio-round-but" :ac="form.title_type==2">
                <i class="iconfont icon-chenggong"></i>
              </div>
              个人/非企业单位
            </span>
          </div>
        </div>
        <div class="val-col">
          <div class="col-label">
            发票抬头
          </div>
          <div class="col-val">
            <input v-model="form.title" placeholder="请输入公司全称"/>
          </div>
        </div>
        <div class="val-col">
          <div class="col-label">
            纳税人识别号
          </div>
          <div class="col-val">
            <input v-model="form.taxpayer_number" placeholder="请输入纳税人识别号"/>
          </div>
        </div>
        <div class="val-col">
          <div class="col-label">
            发票内容
          </div>
          <div class="col-val">
            <input v-model="form.invoices_memo" placeholder="请输入发票内容"/>
          </div>
        </div>
        <div class="val-col">
          <div class="col-label">
            开票金额
          </div>
          <div class="col-val">
            <input v-model="form.invoices_amount" placeholder="可开票额度998.0元"/>
          </div>
        </div>
        <!--<div class="val-col">-->
        <!--<div class="col-label">-->
        <!--开票说明-->
        <!--</div>-->
        <!--<div class="col-val">-->
        <!--<input v-model="form.more_info" placeholder="请输入开票说明"/>-->
        <!--</div>-->
        <!--</div>-->
        <div class="val-col">
          <div class="col-label">
            更多信息
          </div>
          <div class="col-val">
            <input v-model="form.more_info" placeholder="请输入备注，开户行信息等"/>
          </div>
        </div>
      </div>
    </div>
    <div class="row row3">
      <div class="row-title">
        收件信息
      </div>
      <div class="row-val">
        <div class="val-col" v-if="form.invoices_type==2">
          <div class="col-label">
            收件人
          </div>
          <div class="col-val">
            <input v-model="form.addressee" placeholder="请输入收件人"/>
          </div>
        </div>
        <div class="val-col" v-if="form.invoices_type==2">
          <div class="col-label">
            联系电话
          </div>
          <div class="col-val">
            <input v-model="form.telephone" placeholder="请输入联系电话"/>
          </div>
        </div>
        <div class="val-col" v-if="form.invoices_type==2">
          <div class="col-label">
            所在地区
          </div>
          <div class="col-val">
            <input v-model="form.area" placeholder="请输入所在地区"/>
          </div>
        </div>
        <div class="val-col" v-if="form.invoices_type==2">
          <div class="col-label">
            详细地址
          </div>
          <div class="col-val">
            <input v-model="form.address" placeholder="请输入详细地址"/>
          </div>
        </div>
        <div class="val-col" v-if="form.invoices_type==1">
          <div class="col-label">
            电子邮件
          </div>
          <div class="col-val">
            <input v-model="form.email" placeholder="请输入电子邮件"/>
          </div>
        </div>
      </div>
    </div>
    <div class="row row5"  v-if="form.invoices_type==2">
      <div class="row-title">
        支付方式
      </div>
      <div class="row-val">
        <div class="val-col">
          <div class="col-label">
            <i class="iconfont icon-weixinzhifu" style="color: #51b234"></i>微信支付
          </div>
          <div class="col-val" style="text-align: right" @click="form.postage_pay_way=1">
            <span style="color: #999">（全国8元，邮费发票会一同邮寄）</span>
            <div class="radio-round-but" :ac="form.postage_pay_way==1">
              <i class="iconfont icon-chenggong"></i>
            </div>
          </div>
        </div>
        <div class="val-col">
          <div class="col-label">
            <i class="iconfont icon-yuezhifu" style="color: #4394d5"></i>余额支付
          </div>
          <div class="col-val" style="text-align: right" @click="form.postage_pay_way=2">
            <span style="color: #999">（全国8元，邮费发票会一同邮寄）</span>
            <div class="radio-round-but" :ac="form.postage_pay_way==2">
              <i class="iconfont icon-chenggong"></i>
            </div>
          </div>
        </div>
        <div class="val-col">
          <div class="col-label">
            <i class="iconfont icon-huodaofukuan" style="color: #4394d5"></i>货到付款
          </div>
          <div class="col-val" style="text-align: right" @click="form.postage_pay_way=3">
            <span style="color: #999 ;">（全国10元，邮费发票会一同邮寄）</span>
            <div class="radio-round-but" :ac="form.postage_pay_way==3">
              <i class="iconfont icon-chenggong"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="but">申请开票</div>
    <xk-hint-box v-if="hintBox.stateShow" :state="hintBox.state" :content="hintBox.content"></xk-hint-box>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import XkHintBox from '../../module/hintBox/src/hintBox.vue'
  import PullTo from 'vue-pull-to'

  export default {
    components: {XkHintBox, PullTo},
    name: 'invoiceApply',
    computed: {
      ...mapGetters({
        loginData: 'loginData'
      })
    },
    data () {
      return {
        hintBox: {
          stateShow: false,
          state: 'yes',
          content: ''
        },
        form: {
          title: null, // 抬头
          title_type: 1, // 抬头类型
          invoices_type: 1, // 发票类型
          taxpayer_number: null, // 纳税人识别号
          invoices_memo: null, // 发票内容
          invoices_amount: null, // 发票金额
          more_info: null, // 更多信息
          email: null, // 电子邮箱
          invoices_explain: null, // 开票说明
          addressee: null, // 收件人
          telephone: null, // 联系电话
          area: null, // 所在地区
          address: null, // 详细地址
          postage: null, // 邮费
          postage_pay_way: 1, // 邮费支付方式
          invoices_amount_explain: null, // 发票金额说明
          driver_id: null, // 司机ID
          application_date: null, // 申请日期
          customer_id: null, // 客户id
          order_type: null, // 订单类型
          customer_name: null // 客户名称
        }
      }
    },
    watch: {},
    methods: {
      applyFn: function () {
        let that = this
        if (Number(this.Sum) <= Number(this.loginData.passenger.receiptMoney) && Number(this.Sum) > 0) {
          this.$store.dispatch('invoiceApply', {
            'phone': that.loginData.passenger.phone,
            'money': that.Sum,
            'type': '服务费',
            'memo': that.remark,
            fn: (data) => {
              that.$store.dispatch('updateLoginData', {passengerId: that.loginData.passenger.id})
              if (data.code === 0) {
                that.Sum = ''
                that.remark = ''
                that.hintBox = {
                  stateShow: true,
                  state: 'yes',
                  content: '申请提交成功！'
                }
                setTimeout(() => {
                  that.$store.dispatch('invoiceRecord', {
                    'phone': that.loginData && that.loginData.passenger ? that.loginData.passenger.phone : '',
                    'page': 1,
                    'rows': 10,
                    'type': 'upData'
                  })
                  that.hintBox.stateShow = false
                  that.$router.push('/invoice/record')
                }, 1500)
              }
            }
          })
        } else if (this.Sum === '') {
          that.hintBox = {
            stateShow: true,
            state: 'no',
            content: '发票额度不能为空'
          }
          setTimeout(() => {
            that.hintBox.stateShow = false
          }, 1500)
        } else if (Number(this.Sum) === 0) {
          that.hintBox = {
            stateShow: true,
            state: 'no',
            content: '发票额度不能少于0元'
          }
          setTimeout(() => {
            that.hintBox.stateShow = false
          }, 1500)
        } else {
          that.hintBox = {
            stateShow: true,
            state: 'no',
            content: '您的最大开票额度为' + that.loginData.passenger.receiptMoney + '元'
          }
          setTimeout(() => {
            that.hintBox.stateShow = false
          }, 1500)
        }
      }
    },
    mounted: function () {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .invoiceApply {
    box-sizing: border-box;
    width: 100%;
    padding-bottom: 1rem;
    .row {
      background: #fff;
      .row-title {
        line-height: 3.6rem;
        background: #f7f7f7;
        padding: 0 1rem;
        border: 1px solid #eee;
        border-left: none;
        border-right: none;
      }
      .row-val {
        margin: 0 1rem;
      }
      .val-col + .val-col {
        border-top: 1px solid #eee;
      }
      .col-label {
        line-height: 3.6rem;
        display: inline-block;
        width: 6.6rem;
        font-size: 1.1rem;
        color: #666666;
      }
      .col-val {
        display: inline-block;
        line-height: 3.6rem;
        font-size: 1.1rem;
        width: calc(~'100% - 7rem');
        input {
          line-height: 2rem;
          width: 100%;
          box-sizing: border-box;
          padding: 0 .5rem;
          border: none;
          font-size: 1.1rem;
          color: #232323;
        }
        .radio-but {
          display: inline-block;
          width: 45%;
          box-sizing: border-box;
          border: 1px solid #eee;
          height: 3rem;
          margin: 1.5rem 0;
          line-height: 3rem;
          border-radius: .3rem;
          transition: .3s all;
        }
        .radio-but + .radio-but {
          margin-left: calc(~'100% - 92%');
        }
        .radio-but[ac=true] {
          border-color: #f06553;
          color: #f06553;
        }
      }
      .radio-round-but {
        display: inline-block;
        width: 1.3rem;
        line-height: 1.3rem;
        height: 1.3rem;
        vertical-align: middle;
        border-radius: 50%;
        text-align: center;
        border: 1px solid #eee;
        margin-right: .2rem;
        transition: .3s all;
        .icon-chenggong {
          font-size: .4rem;
          opacity: 0;
          color: #fff;
          transition: .3s all;
        }
      }
      .radio-round-but[ac=true] {
        background: #f06553;
        border-color: #f06553;
        .icon-chenggong {
          color: #fff;
          opacity: 1;
          display: inline;
        }
      }
    }
    .row5 {
      .iconfont {
        font-size: 1.8rem;
        display: inline-block;
        vertical-align: middle;
        margin-right: .3rem;
      }
      .radio-round-but {
        .iconfont {
          margin: 0;
        }
      }
    }
    .but {
      margin: 1.5rem 1rem;
      line-height: 3.5rem;
      text-align: center;
      color: #fff;
      background: #f06553;
      border-radius: .3rem;
      font-size: 1.1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// invoiceApply.vue?f57e42a8